<footer class="container-fluid bg-neutral6 py-4">
  <div class="row max-content-width">
    <div class="col text-center">
      <p class="text-white my-0">&copy; {{year}} TIG · Designed and developed by CRPassion Consultores ·</p>
    </div>
  </div>
</footer>